import { render, staticRenderFns } from "./TheoryExamStudentsSelect.vue?vue&type=template&id=47f0c155"
import script from "./TheoryExamStudentsSelect.vue?vue&type=script&lang=ts"
export * from "./TheoryExamStudentsSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports